// Module
var code = `<template class="price-history-by-date">
  <require from="./price-history-by-date.scss"></require>

  <mdc-circular-progress if.bind="loading"></mdc-circular-progress>
  <div show.bind="!loading && !error" class="price-history-by-date__chart" element.ref="chart"></div>
  <message if.bind="error" icon="error" colour="mdc-theme--error" class="price-history-by-date__error">\${error.message}</message>
</template>
`;
// Exports
export default code;